module.exports = __webpack_public_path__ + "img/image7@2x.dcb1f3bf.png";